import React from 'react'
import ContentLoader, { Rect } from 'react-content-loader/native'
import { white } from '@qirapagos/lib/theme/colors'

const RedeeremsDesktopSkeleton = () => (
  <ContentLoader
    speed={3}
    interval={0}
    width="100%"
    height="100vh"
    viewBox="0 0 100% 100vh"
    backgroundColor="#e8e7f7"
    foregroundColor={white}
  >
    <Rect x="3%" y="12vh" rx="8" ry="6" width="29.5%" height="26%" />
    <Rect x="34.5%" y="12vh" rx="8" ry="6" width="29.5%" height="26%" />
    <Rect x="66%" y="12vh" rx="8" ry="6" width="29.5%" height="26%" />
    <Rect x="0.2%" y="40vh" rx="0" ry="0" width="100%" height="60%" />
  </ContentLoader>
)

export default RedeeremsDesktopSkeleton
